/**
 * Variante de diseño que el visitante eligió en la galería (p. ej. "rio-ropa").
 *
 * Vive en sessionStorage y no en Redux para que sobreviva a la recarga igual que
 * la vista previa, y para que la lean los tres servicios que generan la tienda
 * sin tener que pasarla por cada hook.
 */
const KEY = "onboardingAiTemplate";

export const setSelectedTemplate = (template?: string) => {
  if (template) sessionStorage.setItem(KEY, template);
  else sessionStorage.removeItem(KEY);
};

/** Campo `template` para el body de ai-onboarding; vacío si no hay elección. */
export const selectedTemplateBody = (): { template?: string } => {
  const template = sessionStorage.getItem(KEY);
  return template ? { template } : {};
};
